const TimeControl = (props) => {
  const _width = props.width || 24;

  return (
    <svg
      id="icon-TimeControl"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-TimeControl"
      viewBox="0 0 48 48"
      width={_width}
      fill="none"
      {...props}
    >
      <rect
        x="5.5"
        y="6.84"
        width="37"
        height="35"
        rx="4"
        ry="4"
        stroke="#292D32"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M11.357 16.253v-5.978m-5.685 2.989H42.5m-5.686-2.989v5.978"
        stroke="#292D32"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <circle
        cx="24"
        cy="27.353"
        r="10.65"
        stroke="#292D32"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M24 28.578V19.86m4.26 7.493h-5.485"
        stroke="#292D32"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TimeControl;
